import SiteRoutes from './Site/Routes';

function App({initialData} : any) {
  return (
    <SiteRoutes initialData={initialData} />
  );
}

export default App;
